import { ReactNode, useEffect, useRef } from 'react';

import { Box } from 'components/Box';
import { Icon } from 'components/Icon';
import { Status, StatusLabel } from 'components/StatusLabel';
import { VisuallyHidden } from 'components/VisuallyHidden';

import { CloseButton } from './UserNotification.styled';

type Props = {
  status?: Status;
  children: ReactNode;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dismiss?: (...args: Array<any>) => any;
};

export function UserNotification({
  status,
  children,
  dismiss,
  ...props
}: Props) {
  const ref = useRef(null);
  // Using a ref here, because we want to ensure this event handler
  // cannot fire more than once, and the `once` property is more reliable than
  // using state or a functional solution. We only want to run this when
  // the ref is ready, so no deps in the effect

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (ref && ref.current && dismiss) {
      // @ts-expect-error TS(2339): Property 'addEventListener' does not exist on type... Remove this comment to see the full error message
      ref.current.addEventListener('click', dismiss, {
        once: true,
      });
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Box data-qa-id="user-nav-notification" position="relative" {...props}>
      {status && <StatusLabel status={status} />}
      <Box lineHeight={1.375} maxWidth="95%">
        {children}
      </Box>
      {dismiss && (
        <Box position="absolute" top={0} right={0}>
          <div ref={ref}>
            <CloseButton data-qa-id="dismiss-notification">
              <Icon
                initialColorName="lightContentGrey"
                name="close"
                size={12}
              />
              <VisuallyHidden>{getText('Clear notification')}</VisuallyHidden>
            </CloseButton>
          </div>
        </Box>
      )}
    </Box>
  );
}
